module.exports = __webpack_public_path__ + "fa-brands-400.1a575a4138e5f366474f.woff";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fontawesome/fa-brands-400.woff
// module id = ../../../../../src/assets/fonts/fontawesome/fa-brands-400.woff
// module chunks = main